import { usePos } from "../PosStore";
import css from "../Pos.module.css";

const fmt = (v) => Number(v || 0).toLocaleString("ru-RU").replace(/,/g, " ");

const Itog = () => {
    let { possendData } = usePos();
    const discount = Number(possendData.discount || 0);
    const delivery = Number(possendData.deliverysumm || 0);

    return (
        <div className={css.summaryList}>
            <div className={css.summaryRow}>
                <span>Mahsulotlar summasi</span>
                <b>{fmt(possendData.totalsum)} so'm</b>
            </div>
            <div className={css.summaryRow}>
                <span>Chegirma</span>
                <b className={discount > 0 ? css.neg : undefined}>
                    {discount > 0 ? "−" : ""}{fmt(discount)} so'm
                </b>
            </div>
            <div className={css.summaryRow}>
                <span>Yetkazish narxi</span>
                <b>{delivery > 0 ? "+" : ""}{fmt(delivery)} so'm</b>
            </div>
            <div className={css.summaryTotal}>
                <span>Umumiy to'lov</span>
                <b>{fmt(possendData.finalsum)} so'm</b>
            </div>
        </div>
    );
};

export default Itog;
